import React from 'react'

import PageTransition from './templateParts/PageTransition'

export default function SinglePost() {
  return (
    <PageTransition>
      <div>SinglePost</div>
    </PageTransition>
  )
}
